import * as React from "react";
import { SVGProps } from "react";
const SvgHomeServices = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#home-services_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m31.9 15.56-5.83-12a1 1 0 0 0-.9-.56H6.83a1 1 0 0 0-.9.56l-5.83 12A1 1 0 0 0 1 17h4v10a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17h4a1 1 0 0 0 .9-1.44ZM25 17v9H7V15H2.6L7.46 5h17.08l4.86 10H25v2Zm-9.455-6.946a3.6 3.6 0 0 1 .695 4.106l5.809 5.815a1.184 1.184 0 0 1-1.675 1.675l-5.815-5.815-.168.084a3.6 3.6 0 0 1-4.84-4.358l.016-.048.017-.047 2.116 2.112 1.731-.549.549-1.726-2.116-2.112.048-.017.048-.016a3.582 3.582 0 0 1 3.585.896Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="home-services_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeServices;
